import * as types from './types';

const INITIAL_STATE = {
  cycleMenus: [],
  loading: false,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.SIMPLE_AVERAGE_LOADING:
      return { ...state, loading: payload };

    case types.SIMPLE_AVERAGE_GET_CYCLE_MENU_OPTIONS:
      return { ...state, cycleMenus: payload };
    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/pages/simpleaverage/state/simpleaverage/reducer.js